// extracted by mini-css-extract-plugin
module.exports = {"floatingMenu":"helpmenu_floatingMenu__2KkFl","menuItems":"helpmenu_menuItems__3Z31K","mainButton":"helpmenu_mainButton__1wkAy","open":"helpmenu_open__X7tRy"};